import React from 'react'
import { useTranslation } from 'next-i18next'
import { CustomSelect } from 'src/components'
import { Row, Col, Select, Typography } from 'antd'
import { setMassiveCalculationPlaneKeys } from 'src/features'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import styles from './PlaneSelectFields.module.scss'

const { Option } = Select
const { Title } = Typography

const PlaneSelectFields = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { fileKeys, planeKeys } = useAppSelector((state) => state.admin.massiveCalculation)

  return (
    <>
      <Row>
        <Col xs={24} lg={12} className='select-padding'>
          <Title level={5} className={styles['title-position']} type={'secondary'}>
            {t('admin.MassiveCalculate.FromField')}
          </Title>
          <CustomSelect
            placeholder={t('admin.MassiveCalculate.FromField')}
            value={planeKeys.from}
            onChange={(value: string) => dispatch(setMassiveCalculationPlaneKeys({ ...planeKeys, from: value }))}
          >
            {fileKeys.map((item, idx) => (
              <Option key={idx} value={item}>{item}</Option>
            ))}
          </CustomSelect>
        </Col>
        <Col xs={24} lg={12} className='select-padding'>
          <Title level={5} className={styles['title-position']} type={'secondary'}>
            {t('admin.MassiveCalculate.ToField')}
          </Title>
          <CustomSelect
            placeholder={t('admin.MassiveCalculate.ToField')}
            value={planeKeys.to}
            onChange={(value: string) => dispatch(setMassiveCalculationPlaneKeys({ ...planeKeys, to: value }))}
          >
            {fileKeys.map((item, idx) => (
              <Option key={idx} value={item}>{item}</Option>
            ))}
          </CustomSelect>
        </Col>
      </Row>

      <Row>
        <Col xs={24} lg={12} className='select-padding'>
          <Title level={5} className={styles['title-position']} type={'secondary'}>
            {t('admin.MassiveCalculate.PaxesField')}
          </Title>
          <CustomSelect
            placeholder={t('admin.MassiveCalculate.PaxesField')}
            value={planeKeys.paxes}
            onChange={(value: string) => dispatch(setMassiveCalculationPlaneKeys({ ...planeKeys, paxes: value }))}
          >
            {fileKeys.map((item, idx) => (
              <Option key={idx} value={item}>{item}</Option>
            ))}
          </CustomSelect>
        </Col>
        <Col xs={24} lg={12} className='select-padding'>
          <Title level={5} className={styles['title-position']} type={'secondary'}>
            {t('admin.MassiveCalculate.ClassField')}
          </Title>
          <CustomSelect
            placeholder={t('admin.MassiveCalculate.ClassField')}
            value={planeKeys.classType}
            onChange={(value: string) => dispatch(setMassiveCalculationPlaneKeys({ ...planeKeys, classType: value }))}
          >
            {fileKeys.map((item, idx) => (
              <Option key={idx} value={item}>{item}</Option>
            ))}
          </CustomSelect>
        </Col>
      </Row>

      <Row>
        <Col xs={24} lg={24} className='select-padding'>
          <Title level={5} className={styles['title-position']} type={'secondary'}>
            {t('admin.MassiveCalculate.RoundTripField')}
          </Title>
          <CustomSelect
            placeholder={t('admin.MassiveCalculate.RoundTripField')}
            value={planeKeys.roundtrip}
            onChange={(value: string) => dispatch(setMassiveCalculationPlaneKeys({ ...planeKeys, roundtrip: value }))}
          >
            {fileKeys.map((item, idx) => (
              <Option key={idx} value={item}>{item}</Option>
            ))}
          </CustomSelect>
        </Col>
      </Row>
    </>
  )
}

export default PlaneSelectFields
